import { queryString } from '@olivierpascal/helpers';

import type { IAppRegion } from '~/lib/appSettings';
import { appRegionsSettings } from '~/lib/appSettings';

export type ILegacyDashboardUrlProps = {
  platform: 'blog' | 'crowd';
  region: IAppRegion;
  path: string;
  searchParams?: Record<string, string>;
  authToken?: string;
  userId?: string;
};

export const getLegacyDashboardUrl = (
  props: ILegacyDashboardUrlProps,
): string => {
  const { platform, region, path, authToken, userId, searchParams } = props;

  const domain =
    appRegionsSettings[region][
      platform === 'crowd' ? 'legacyCrowdUrl' : 'legacyDashboardUrl'
    ];
  const url = `${domain}${path}?${queryString.build({
    auth_token: authToken,
    userId,
    ...searchParams,
  })}`;

  return url;
};
